import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "reactstrap";
import { resetModal } from "../../state/actions/modalAction";
import closeIcon from "../../assets/images/close.png";
import "./Modal.scss";
import { isEnterPress } from "../../utils/helpers/accessibilityUtil";

const FullScreenModal = (props) => {
  const dispatch = useDispatch();
  const { isOpen, child , idfor} = useSelector((state) => state.modalReducer);
  const closeModal = () => {
    dispatch(resetModal());
  };

  const modelRef = useRef(null);

  
  useEffect(()=>{
    setTimeout(() => {      
      if(modelRef.current){
        const el =  modelRef.current?._element?.querySelectorAll('.modal.fade.show')[0];
        el?.setAttribute('aria-labelledby',"dialogTitle");
        el?.setAttribute('aria-modal',"true")  
      }
    }, 1000);
  },[modelRef , isOpen])

  return (
    <div aria-modal="true" aria-labelledby="dialogTitle">
      
      <Modal
        size={child?.props?.size ? child.props.size : "lg"}
        isOpen={isOpen}
        toggle={closeModal}
        centered={child?.props?.center ? child.props.center : false}
        role="dialog"
        ref={modelRef}
        parentNode={{
          ariaModal:"true",
          labelledby: "סגור חלונית",
        }}
        aria={{
          describedby: "full_description",
          modal:"true"
        }}
        autoFocus={true} 
        aria-pressed={true}
      >
        <div
         style={{ height: 10 }}
          id="close-popup-btn"
          aria-labelledby="close-popup-btn"
          alt="סגור חלונית"   
           >
          <img
            src={closeIcon}
            onClick={closeModal}
            onKeyPress={(event) => isEnterPress(event) && closeModal()}
            alt="סגור חלונית"
            className="close"
            tabIndex={0}
            for={idfor}
            role="button"
            aria-label="סגור חלונית"
          />
        </div>
        <div dir={props.dir} className={"modal-body " + props.dir}>
          {child}
        </div>
      </Modal>
    </div>
  );
};

export default FullScreenModal;
